/**
 * Respawn13 — Light / Dark theme toggle
 * Persists preference in localStorage; emits 'theme:change' event.
 * The inline bootstrap in theme.liquid sets data-theme before paint.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'respawn13-theme';
  var html = document.documentElement;

  function getCurrentTheme() {
    return html.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  }

  function applyTheme(mode) {
    html.setAttribute('data-theme', mode);
    try { localStorage.setItem(STORAGE_KEY, mode); } catch (e) {}
    html.dispatchEvent(new CustomEvent('theme:change', { detail: { mode: mode } }));
  }

  function toggle() {
    applyTheme(getCurrentTheme() === 'dark' ? 'light' : 'dark');
  }

  function bind() {
    var buttons = document.querySelectorAll('[data-theme-toggle]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', toggle);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  window.Respawn = window.Respawn || {};
  window.Respawn.theme = {
    get: getCurrentTheme,
    set: applyTheme,
    toggle: toggle
  };
})();
